module.exports = __webpack_public_path__ + "img/clock_outline.0512e8ad.svg";